const config = {
  apiUrl: 'production' === process.env.NODE_ENV ? 'https://api.blue-black.life' : '/',
  //apiUrl: 'http://smile.blueblack.life:8000',
};

export default config;
